<template>
  <div class="balance-sheet-month">
    <div class="section operations" style="margin-bottom:1px;">
      <el-form inline style="margin-bottom:-8px;">
        <!--会计期间-->
        <el-form-item label="Accounting Interval">
          <el-select ref="fromFPRef" v-model="form.fromFP" style="width: 120px;" placeholder="Please select">
            <el-option
              v-for="(item,index) in fiscalPeriods"
              :key="index"
              :label="fiscalPeriodLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="-">
          <el-select v-model="form.toFP" style="width: 120px;" placeholder="Please select">
            <el-option
              v-for="(item,index) in fiscalPeriods"
              :key="index"
              :label="fiscalPeriodLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <!--部门-->
        <el-form-item label="OP Dept">
          <office-department-cascader
            v-model="form.departmentIds"
            placeholder="Please input keyword"
            style="width: 160px;"
          />
        </el-form-item>
        <!--销售-->
        <el-form-item label="Sales">
          <cargo-advance-select
            :callback-params="{key:'sales'}"
            :default-value="form.sales"
            :select-type="selectTypeNames.basic_data_User"
            callback-method-type="value"
            placeholder="Please input keyword"
            filterable
            style="width: 160px;"
            @parentCallBack="selectChangeHandler"
          />
        </el-form-item>
        <el-form-item>
          <!--查询-->
          <el-button class="el-margin" type="primary" @click="doSearch">Search</el-button>
          <!--新增明细科目-->
          <el-button class="el-margin" type="primary" @click="newLineItems">New line items</el-button>
          <!--新增统计科目-->
          <el-button class="el-margin" type="primary" @click="newStatisticalItems">New statistical items</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="section" style="flex: 1;padding: 0px;">
      <cargo-ag-grid
        :show-side-bar="false"
        :column-defs="columnDefs"
        :grid-options="gridOptions"
        :grid-params.sync="girdParams"
        :auto-fit-content="false"
        :row-data="rowData"
        style="height: 800px;"
      />
    </div>
    <statement-element-dialog
      :visible="statementElementDialog.visible"
      :atb-dictionary="atbDictionary"
      :account-set="accountSet"
      :elementformula-editable="statementElementDialog.elementformulaEditable"
      :statement-description-uuid="statementElementDialog.statementDescriptionUuid"
      :statement-description="statementElementDialog.statementDescription"
      @close="statementElementDialog.visible=false"
    />
    <element-formula-new-dialog
      :visible="elementFormulaNewDialog.visible"
      :atb-dictionary="atbDictionary"
      :account-set="accountSet"
      :elementformula-editable="elementFormulaNewDialog.elementformulaEditable"
      :statement-description-uuid="elementFormulaNewDialog.statementDescriptionUuid"
      :statement-description="elementFormulaNewDialog.statementDescription"
      @close="elementFormulaNewDialog.visible=false"
    />
    <element-formula-edit-dialog
      :visible="elementFormulaEditDialog.visible"
      :atb-dictionary="atbDictionary"
      :account-set="accountSet"
      :elementformula-editable="elementFormulaEditDialog.elementformulaEditable"
      :statement-element-description-uuid="elementFormulaEditDialog.statementElementDescriptionUuid"
      :statement-element-description="elementFormulaEditDialog.statementElementDescription"
      statement-name="BalanceSheetMonth"
      @close="elementFormulaEditDialog.visible=false"
    />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import officeDepartmentCascader from '@/components/Cargo/Common/officeDepartmentCascader'
import * as statementDescriptionApi from '@/api/financeManage/statementDescription'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import * as NumberUtils from '@/utils/NumberUtils'
import { DocumentManage } from '@/utils/commonUtil'
import ElementFormulaEditDialog from '@/views/cargo/v0/FinanceManage/UsaReport/components/ElementFormulaEditDialog'
import StatementElementDialog from '@/views/cargo/v0/FinanceManage/UsaReport/components/StatementElementDialog'
import ElementFormulaNewDialog from '@/views/cargo/v0/FinanceManage/UsaReport/components/ElementFormulaNewDialog'
import { exportExcelMultiHeader } from '@/utils/tableDataExportUtils'
import { ABC_US } from '@/utils/StrUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { repareNodeSort } from '@/utils/commonUtil'
import jc from 'json-cycle'

export default {
  name: 'BalanceSheetMonth',
  components: { cargoAdvanceSelect, officeDepartmentCascader, StatementElementDialog, ElementFormulaEditDialog, ElementFormulaNewDialog },
  props: {
    accountSet: { type: Object, default: null },
    statementDescription: { type: Object, default: null }
  },
  data() {
    return {
      documentManage: new DocumentManage(),
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          sortable: false // 去掉每列的排序
        },
        suppressContextMenu: false,
        getContextMenuItems: () => {
          const self = this
          return [
            {
              name: 'Export excel',
              action: function() {
                self.exportExcelHandler()
              }
            }
          ]
        }
      },
      rowData: [],
      atbDictionary: {},
      statementElementDialog: {
        visible: false,
        elementformulaEditable: true,
        statementDescriptionUuid: '',
        statementDescription: {}
      },
      elementFormulaNewDialog: {
        visible: false,
        elementformulaEditable: true,
        statementDescriptionUuid: '',
        statementDescription: {}
      },
      elementFormulaEditDialog: {
        visible: false,
        elementformulaEditable: true,
        statementElementDescriptionUuid: '',
        statementElementDescription: {}
      },
      selectTypeNames: TYPE_NAMES,
      form: {
        fromFP: '',
        toFP: '',
        departmentId: 0,
        departmentIds: [],
        sales: 0
      },
      monthShow: {
        month1: true,
        month2: true,
        month3: true,
        month4: true,
        month5: true,
        month6: true,
        month7: true,
        month8: true,
        month9: true,
        month10: true,
        month11: true,
        month12: true
      }
    }
  },
  computed: {
    // 当前会计期间
    currentFiscalPeriod() {
      return this.accountSet ? this.accountSet.currentFiscalPeriod : null
    },
    // 初始会计期间
    initialFiscalPeriod() {
      return this.accountSet ? this.accountSet.initialFiscalPeriod : null
    },
    // 会计期间
    fiscalPeriods() {
      return this.accountSet ? this.accountSet.fiscalPeriod : []
    },
    fiscalPeriod() {
      if (this.fiscalPeriods && this.form.fromFP) {
        return this.fiscalPeriods.find(fp => fp.uuid === this.form.fromFP)
      }
      return null
    },
    yearHeader() {
      if (this.fiscalPeriod) return this.fiscalPeriod.year
      if (this.currentFiscalPeriod) return this.currentFiscalPeriod.year
      return '2022'
    },
    columnDefs() {
      return [
        { headerName: 'Line No.', field: 'lineNo', width: 90,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: 'Account No.', field: 'elementNo', width: 120, sortable: true,
          cellRenderer: params => {
            return ColumnUtils.accountNoLabelItemRenderer(params.value)
          }
        },
        { headerName: 'Account name', field: 'name', width: 200,
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('statementColumnDescriptionClickHandler')
            return `<a onclick="${methodPath}('${params.data.uuid}')" style="text-decoration: underline;">${params.value}</a>`
          }
        },
        { headerName: this.yearHeader + '01', field: 'month1', width: 100,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          },
          hide: !this.monthShow.month1
        },
        { headerName: this.yearHeader + '02', field: 'month2', width: 100,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          },
          hide: !this.monthShow.month2
        },
        { headerName: this.yearHeader + '03', field: 'month3', width: 100,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          },
          hide: !this.monthShow.month3
        },
        { headerName: this.yearHeader + '04', field: 'month4', width: 100,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          },
          hide: !this.monthShow.month4
        },
        { headerName: this.yearHeader + '05', field: 'month5', width: 100,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          },
          hide: !this.monthShow.month5
        },
        { headerName: this.yearHeader + '06', field: 'month6', width: 100,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          },
          hide: !this.monthShow.month6
        },
        { headerName: this.yearHeader + '07', field: 'month7', width: 100,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          },
          hide: !this.monthShow.month7
        },
        { headerName: this.yearHeader + '08', field: 'month8', width: 100,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          },
          hide: !this.monthShow.month8
        },
        { headerName: this.yearHeader + '09', field: 'month9', width: 100,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          },
          hide: !this.monthShow.month9
        },
        { headerName: this.yearHeader + '10', field: 'month10', width: 100,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          },
          hide: !this.monthShow.month10
        },
        { headerName: this.yearHeader + '11', field: 'month11', width: 100,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          },
          hide: !this.monthShow.month11
        },
        { headerName: this.yearHeader + '12', field: 'month12', width: 100,
          cellStyle: { textAlign: 'right' },
          cellRenderer: params => {
            return this.amountLabelItemRenderer(params.value)
          },
          hide: !this.monthShow.month12
        }
      ]
    },
    excelColumnDefs() {
      return [
        { headerName: 'Line No.', field: 'lineNo', width: 90, hide: false },
        { headerName: 'Account No.', field: 'elementNo', width: 120,
          cellRenderer: params => { return ColumnUtils.accountNoLabelItemRenderer(params.value) + ' ' },
          hide: false
        },
        { headerName: 'Account name', field: 'name', width: 200, hide: false },
        { headerName: this.yearHeader + '01 ', field: 'month1', width: 100,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: !this.monthShow.month1
        },
        { headerName: this.yearHeader + '02 ', field: 'month2', width: 100,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: !this.monthShow.month2
        },
        { headerName: this.yearHeader + '03 ', field: 'month3', width: 100,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: !this.monthShow.month3
        },
        { headerName: this.yearHeader + '04 ', field: 'month4', width: 100,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: !this.monthShow.month4
        },
        { headerName: this.yearHeader + '05 ', field: 'month5', width: 100,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: !this.monthShow.month5
        },
        { headerName: this.yearHeader + '06 ', field: 'month6', width: 100,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: !this.monthShow.month6
        },
        { headerName: this.yearHeader + '07 ', field: 'month7', width: 100,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: !this.monthShow.month7
        },
        { headerName: this.yearHeader + '08 ', field: 'month8', width: 100,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: !this.monthShow.month8
        },
        { headerName: this.yearHeader + '09 ', field: 'month9', width: 100,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: !this.monthShow.month9
        },
        { headerName: this.yearHeader + '10 ', field: 'month10', width: 100,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: !this.monthShow.month10
        },
        { headerName: this.yearHeader + '11 ', field: 'month11', width: 100,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: !this.monthShow.month11
        },
        { headerName: this.yearHeader + '12 ', field: 'month12', width: 100,
          cellRenderer: params => { return params.value ? params.value : '' },
          hide: !this.monthShow.month12
        }
      ]
    },
    elementFormulaEditable() {
      if (!this.currentFiscalPeriod || !this.initialFiscalPeriod) {
        return false
      }
      if (this.currentFiscalPeriod.year === this.initialFiscalPeriod.year &&
        this.currentFiscalPeriod.month === this.initialFiscalPeriod.month) {
        return true
      }
      if (this.currentFiscalPeriod.year !== this.initialFiscalPeriod.year && this.currentFiscalPeriod.month === 1) {
        return true
      }
      return false
    },
    fromFP() {
      if (this.fiscalPeriods && this.form.fromFP) {
        return this.fiscalPeriods.find(fp => fp.uuid === this.form.fromFP)
      }
      return null
    },
    toFP() {
      if (this.fiscalPeriods && this.form.toFP) {
        return this.fiscalPeriods.find(fp => fp.uuid === this.form.toFP)
      }
      return null
    }
  },
  watch: {
    accountSet(newVal) {
      if (newVal) {
      }
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('statementColumnDescriptionClickHandler', function(data) {
      self.statementColumnDescriptionClickHandler(data)
    })
  },
  methods: {
    fiscalPeriodLabelFun(data) {
      if (data) {
        return data.year + '.' + data.month
      }
      return ''
    },
    selectChangeHandler(params) {
      this.form[params.key] = params.value
    },
    doSearch() {
      const params = {}
      params.accountSetKey = this.accountSet.uuid
      params.statementName = this.statementDescription.statementName
      params.statementDescriptionUuid = this.statementDescription.uuid
      const fromFP = this.fromFP
      const toFP = this.toFP
      if (fromFP) {
        params.month = fromFP.month
        params.year = fromFP.year
      }
      if (toFP) {
        params.endMonth = toFP.month
        params.year = toFP.year
      }
      // 相同年
      if (fromFP && fromFP.year && toFP && toFP.year && fromFP.year !== toFP.year) {
        this.$refs.fromFPRef.focus()
        this.$message.warning(this.$t('CargoMsg.Cargo_PSFPOTSY'), this.$t('CargoMsg.Cargo_Tips'))
        return
      }
      if (this.form.sales) params.sales = this.form.sales
      if (this.form.departmentId) params.departmentId = this.form.departmentId
      if (this.form.departmentIds.length > 0) {
        const set = new Set()
        for (const item of this.form.departmentIds) {
          for (let i = 1; i < item.length; ++i) {
            set.add(item[i])
          }
        }
        params.departmentIds = [...set].join(',')
      }
      // 重置
      for (let m = 1; m <= 12; m++) {
        this.showMonth(m)
      }
      this.gridOptions.api.setColumnDefs(this.columnDefs)
      this.rowData = this.statementDescription.statementElementDescription
      const loading = getLoading()
      statementDescriptionApi.getStatement2UsaReport(params).then(resp => {
        this.getStatementResult(resp)
      }).finally(() => loading.close())
    },
    getStatementResult(resp) {
      const result = resp.data
      if (result && result.atbs && result.atbs instanceof Array) {
        for (const atb of result.atbs) {
          this.atbDictionary[atb.accountTitle] = atb
        }
      }
      if (result && result.dataProvider) {
        this.rowData = result.dataProvider
      }
    },
    amountLabelItemRenderer(value) {
      if (value) {
        return NumberUtils.formatRoundNumber(value, 2)
      }
      return ''
    },
    statementColumnDescriptionClickHandler(value) {
      const elementDescription = this.statementDescription.statementElementDescription.find(element => element.uuid === value)
      this.elementFormulaEditDialog.statementElementDescriptionUuid = elementDescription.uuid
      this.elementFormulaEditDialog.statementElementDescription = elementDescription
      this.elementFormulaEditDialog.elementformulaEditable = true // this.elementFormulaEditable
      this.elementFormulaEditDialog.visible = true
    },
    exportExcelHandler() {
      const columnDefs = []
      this.excelColumnDefs.forEach(column => { if (!column.hide) columnDefs.push({ colDef: column }) })
      let exportFileName = 'Balance Sheet Month - Period Analysis to '
      if (this.toFP) {
        exportFileName = exportFileName + this.toFP.year + this.toFP.month
      }
      const multiHeader = []
      const row = []
      columnDefs.forEach(column => { row.push('') })
      row[0] = this.$store.getters.currentOffice.englishName
      multiHeader.push(row)
      const row1 = row.concat()
      row1[0] = 'Balance Sheet - Period Analysis to ' + this.toFP.year + this.toFP.month
      multiHeader.push(row1)
      const row2 = row.concat()
      row2[0] = 'Printed by ' + this.$store.getters.userInfo.englishName + ' ' + this.$moment(new Date()).format('D-MMM-YY HH:mm:ss A')
      multiHeader.push(row2)
      const col = columnDefs.length
      const colName = ABC_US[col - 1]
      const merges = ['A1:' + colName + '1', 'A2:' + colName + '2', 'A3:' + colName + '3']
      // CARGO-31635，USA REPORT报表排序优化
      const nodes = []
      this.gridOptions.api.forEachNode(node => { nodes.push(node) })
      repareNodeSort(nodes)
      const rows = nodes.map(item => item.data)
      const newRows = jc.decycle(rows)
      let rowCount = 1
      newRows.forEach(row => { row.lineNo = rowCount; rowCount++ }) // 重置Line No
      exportExcelMultiHeader(multiHeader, merges, exportFileName, newRows, columnDefs)
    },
    defaultFpUuid() {
      if (this.form.fromFP) return
      if (this.fiscalPeriods) {
        this.form.fromFP = this.fiscalPeriods[0].uuid
        this.form.toFP = this.fiscalPeriods[0].uuid
      }
    },
    // 新增明细科目
    newLineItems() {
      this.statementElementDialog.elementformulaEditable = true
      this.statementElementDialog.statementDescriptionUuid = this.statementDescription.uuid
      this.statementElementDialog.statementDescription = this.statementDescription
      this.statementElementDialog.visible = true
    },
    // 新增统计科目
    newStatisticalItems() {
      this.elementFormulaNewDialog.elementformulaEditable = true
      this.elementFormulaNewDialog.statementDescriptionUuid = this.statementDescription.uuid
      this.elementFormulaNewDialog.statementDescription = this.statementDescription
      this.elementFormulaNewDialog.visible = true
    },
    // 显示月份
    showMonth(m) {
      if (this.fromFP && this.toFP) {
        if (this.fromFP.month > m || this.toFP.month < m) {
          this.monthShow['month' + m] = false
          return
        }
      }
      this.monthShow['month' + m] = true
    }
  }
}
</script>

<style scoped>

</style>
